import React, { forwardRef, useContext } from 'react';
import styles from '../Input.module.css';
import { InputContext } from '../Input';
import { passthroughChildrenWithDisabledState } from '../__utils';

interface IconProps {
  children: React.ReactNode;
  className?: string;
}

const InputEndIcon = forwardRef<HTMLDivElement, IconProps>(
  ({ children, className }, ref) => {
    const state = useContext(InputContext);

    const processedChildren = passthroughChildrenWithDisabledState(
      children,
      state.isDisabled,
    );

    return (
      <div
        ref={ref}
        className={`
          ${styles['input-field__endIcon']} 
          ${className || ''}
        `}
        {...(state.isDisabled ? { 'data-disabled': true } : {})}
        {...(state.isInvalid ? { 'data-invalid': true } : {})}
      >
        {processedChildren}
      </div>
    );
  },
);
InputEndIcon.displayName = 'Input.EndIcon';

export default InputEndIcon;
